import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-bee84b94"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "operation"
};
const _hoisted_2 = ["onClick", "src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "img-tips"
};
const _hoisted_5 = {
  class: "language"
};
import { useVodLanguages } from '@/utils/cacheData';
import { getLanguageFullName } from '@/utils/tools';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    imgList: {
      type: Array,
      default: []
    },
    operationList: {
      type: Array,
      default: []
    },
    imageSize: {
      type: String,
      default: '210*300px'
    },
    imageStyle: {
      type: String,
      default: 'width: 210px; height: 300px;'
    },
    mainStyle: {
      type: Object,
      default: {
        width: '210px'
      }
    },
    imageTitle: {
      type: String,
      default: '系列封面图'
    },
    labelText: {
      type: Object,
      default: {
        language: '海报语言',
        name: '海报名称'
      }
    }
  },

  setup(__props) {
    const props = __props; // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      data.languageOptions = res;
    };

    getAllLanguages();
    const data = reactive({
      languageOptions: []
    });
    return (_ctx, _cache) => {
      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.imgList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "img-item",
          key: index
        }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.operationList, (operation, operationIndex) => {
          return _openBlock(), _createElementBlock("img", {
            key: operationIndex,
            onClick: $event => operation.action(item, index),
            src: operation.src,
            alt: ""
          }, null, 8, _hoisted_2);
        }), 128))]), _createElementVNode("div", {
          class: "img-warp",
          style: _normalizeStyle(__props.imageStyle)
        }, [_createElementVNode("img", {
          class: "img",
          style: _normalizeStyle(__props.imageStyle),
          src: item.url ? item.url : item.file && item.file[0] ? item.file[0] : '',
          alt: ""
        }, null, 12, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(_ctx.$t(__props.imageTitle)), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('尺寸')) + "：" + _toDisplayString(__props.imageSize), 1)])], 4), _createElementVNode("div", {
          class: "img-main",
          style: _normalizeStyle(__props.mainStyle)
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_ctx.$t(__props.labelText.language)) + ": ", 1), _createElementVNode("span", null, _toDisplayString(_unref(getLanguageFullName)(item.language, data.languageOptions)), 1)])], 4)]);
      }), 128);
    };
  }

});